// ======================================================================
// File Name       : MultiLanguageProcessResultListContainer
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, isInvalid, reduxForm } from 'redux-form';
import * as MultiLanguageAction from '../../actions/MultiLanguageAction';
import MultiLanguageResultList from '../../components/multiLanguage/MultiLanguageResultList';
import { RETURN_MAX_NUM } from '../../constants';
import { MULTI_LANGUAGE_PROCESS_DETAIL } from '../../constants/PathConstants';
import { hideLoading, showLoading } from '../../utils/PageUtils';

class MultiLanguageProcessResultListContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      searchInfo: {
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM,
      },
    };
    this.getStartEndData = this.getStartEndData.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.updateData = this.updateData.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    this.initData();
  }

  initData() {
    const startPosition = 0;
    const param = this.createParams(startPosition);
    this.props.dispatch(MultiLanguageAction.searchMultiLanguageProcessResultList(param));
  }

  getStartEndData(startPosition) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchData(startPosition);
  }

  searchData(startPosition) {
    const { invalid } = this.props;
    if (invalid) { return; }
    const paramSearch = this.createParams(startPosition);
    this.props.dispatch(MultiLanguageAction.searchMultiLanguageProcessResultList(paramSearch));
  }

  createParams(startPosition) {
    const filterData = {};
    if (!isNaN(parseInt(startPosition, 10))) {
      filterData.startPosition = startPosition;
    }

    filterData.returnMaxNum = RETURN_MAX_NUM;
    return filterData;
  }

  updateData() {
    const { invalid } = this.props;
    if (invalid) return;
    const startPosition = 0;
    this.props.change('startPosition', 0);
    // #7103 START
    const paramSearch = this.createParams(startPosition);
    this.props.dispatch(showLoading());
    this.props.dispatch(MultiLanguageAction.searchMultiLanguageProcessResultList(paramSearch)).then(() => {
      this.props.dispatch(hideLoading());
    });
    // #7103 END
  }

  goToDetail(multiLanguageProcessManagementIdAuto) {
    const path = MULTI_LANGUAGE_PROCESS_DETAIL.replace(':id', multiLanguageProcessManagementIdAuto);
    this.props.history.push(path);
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { multiLanguageProcessResultList } = this.props;
    const { hoverIndex } = this.state;
    return (
      <div>
        <MultiLanguageResultList
          getStartEndData={this.getStartEndData}
          multiLanguageProcessResultList={multiLanguageProcessResultList}
          goToDetail={this.goToDetail}
          updateData={this.updateData}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const invalid = isInvalid('multiLanguageProcessResultListForm')(state);
  const { multiLanguageProcessResultList } = state.multiLanguage;
  return {
    invalid,
    multiLanguageProcessResultList,
    formValues: getFormValues('multiLanguageProcessResultListForm')(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'multiLanguageProcessResultListForm',
    touchOnChange: true,
  })(MultiLanguageProcessResultListContainer),
);
